/**
 * WEBM.
 *
 * @group DRM
 *
 * @beta
 */
export const WEBM = 'webm';
